import React from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "antd";
import styles from "../DashBoard/DashBoardMobile/DashBoardMobile.module.scss";
import { rightArrow } from "../../assets/images";

type LinkType = {
  to: string;
  text: string;
  onClick: () => void;
};

type Props = {
  links: LinkType[];
};

const MobileServicesListView: React.FC<Props> = ({ links }) => {
  return (
    <>
      {links.map((link, i) => (
        <Link
          key={i}
          to={link.to}
          className={styles.customLink}
          onClick={link.onClick}
        >
          <Row justify="space-between" className={styles.serviceRow}>
            <Col className={styles.serviceHeading}>{link.text}</Col>
            <Col>
              <img alt="Right-Arrow" src={rightArrow} />
            </Col>
          </Row>
        </Link>
      ))}
    </>
  );
};

export default MobileServicesListView;
